// const TIMEOUT = 200;

// function timeout() {
//     return new Promise((resolve, reject) => {
//         setTimeout(() => resolve(), window.env.MOE_TIMEOUT || TIMEOUT);
//     })
// }

// function defineTimeout(func) {
//     return (...args) => {
//         const promise = func.apply(this, args);
//         const timeoutPromise = timeout();
//         return Promise.race([promise, timeoutPromise]);
//     }
// }

// export const trackMOEEvent = defineTimeout((eventKey="AEH", attributes=undefined) => {
//     try {
//         if (typeof window.Moengage !== "undefined") {
//             if(attributes === undefined) {
//                 return window.Moengage.track_event(eventKey);
//             } else {
//                 return window.Moengage.track_event(eventKey, attributes);
//             }
//         } else {
//             return Promise.resolve();
//         }
//     } catch (error) {
//         console.log(error);
//         return Promise.resolve();
//     }
// })

// export const createMOESession = defineTimeout((userId) => {
//     try {
//         if (typeof window.Moengage !== "undefined") {
//             window.Moengage.add_unique_user_id(userId);
//         }
//     } catch (error) {
//         console.log(error);
//     }
// })

// export const destroyMOESession = defineTimeout(() => {
//     try {
//         if (typeof window.Moengage !== "undefined") {
//             return window.Moengage.destroy_session();
//         } else {
//             return Promise.resolve();
//         }
//     } catch (error) {
//         console.log(error);
//         return Promise.resolve();
//     }
// })

// export const setUserMOEAttribute = defineTimeout((key, value) => {
//     try {
//         if (typeof window.Moengage !== "undefined") {
//             return window.Moengage.add_user_attribute(key, value);
//         } else {
//             return Promise.resolve();
//         }
//     } catch (error) {
//         console.error(error);
//         return Promise.resolve();
//     }
// })

// export const trackMOEServiceError = (attributes={}) => {
//     const errorEventKey = "AEH_SERVICE_ERROR";
//     try {
//         if (typeof window.Moengage !== "undefined") {
//             if(attributes === undefined) {
//                 return window.Moengage.track_event(errorEventKey);
//             } else {
//                 return window.Moengage.track_event(errorEventKey, attributes);
//             }
//         } else {
//             return Promise.resolve();
//         }
//     } catch (error) {
//         console.log(error);
//         return Promise.resolve();
//     }
// }
// -------


export const trackMOEEvent = () => new Promise((resolve, reject) => {
    try { resolve("track moengage events"); }
    catch (error) { reject(error); }
});

export const createMOESession = () => new Promise((resolve, reject) => {
    try { resolve("create moengage session"); }
    catch (error) { reject(error); }
});

export const destroyMOESession = () => new Promise((resolve, reject) => {
    try { resolve("destroy moengage session"); }
    catch (error) { reject(error); }
});

export const setUserMOEAttribute = () => new Promise((resolve, reject) => {
    try { resolve("set user moengage attribute"); }
    catch (error) { reject(error); }
});

export const trackMOEServiceError = () => new Promise((resolve, reject) => {
    try { resolve("track moengage service error"); }
    catch (error) { reject(error); }
});

